<template>
  <h2 class="text-xl font-bold mt-4 mb-2 text-gray-700 w-full">
    <a href="" name="changelog"></a>
    Changelog
  </h2>

  <ul class="changelog">
    <li>
      <div class="text-gray-600 text-xs">2020-05-29</div>
      <div class="font-bold text-gray-700 py-2">0.1a &ndash; Initial version</div>

      <div class="text-gray-800 pb-6">
        <p>
          First stab at the original idea of being able to easily arrange DJs from different
          timezones onto a one track of events. Some things to note:
        </p>

        <p>
          Admin functionality should not rely on mobile support. This is a complex tool, we need the
          support from the browser to do proper UI with complex interactions. Also there is so much
          data on the screen that mobile devices just can't fit enough of it in one screen. For now
          the admin functionality needs a desktop screen and browser. Note: DJs and non-admins can
          still use the tool fine.
        </p>

        <p>
          The tool revolves heavily around timezones. Almost every timezone visible in the UI is
          clickable. Clicking a timezone sets the timezone active. This affects all local times
          throughout the app except the default timezone times which are immutable and do not ever
          change.
        </p>
      </div>
    </li>
  </ul>
</template>
<style lang="css">
.changelog strong {
  @apply font-bold;
}

.changelog p + p,
.changelog ul + p {
  @apply mt-4;
}

.changelog ol,
.changelog ul {
  @apply mt-4 list-inside;
}

.changelog ul ul {
  @apply ml-8 mt-0 list-inside;
}
</style>
